import { render, staticRenderFns } from "./categoryNaviItem.vue?vue&type=template&id=596d60ae&scoped=true&"
import script from "./categoryNaviItem.vue?vue&type=script&lang=ts&"
export * from "./categoryNaviItem.vue?vue&type=script&lang=ts&"
import style0 from "./categoryNaviItem.vue?vue&type=style&index=0&id=596d60ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "596d60ae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Users\\its_bas_sp_schramwy\\serviceportal\\RUB.Serviceportal\\ClientApp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('596d60ae', component.options)
    } else {
      api.reload('596d60ae', component.options)
    }
    module.hot.accept("./categoryNaviItem.vue?vue&type=template&id=596d60ae&scoped=true&", function () {
      api.rerender('596d60ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/molecules/categoryNaviItem.vue"
export default component.exports